import VariablesContent from "./VariablesContent";
import PropType from "prop-types";
import BaseComponent from "../../../../lib/components/BaseComponent";
import Window from "../../../../lib/components/window/Window";
import TabContent from "../../../../lib/components/tabbar/TabContent";
import React, {createRef} from "react";
import TabBarVertical from "../../../../lib/components/tabbar/TabBarVertical";
import ButtonTabVariables from "../tabbar/ButtonTabVariables";
import VerticalLayout from "../../../../lib/components/layouts/VerticalLayout";
import VariablesButtonGroup from "./VariablesButtonGroup";
import TabContainerVerticalVariables from "../tabbar/TabContainerVerticalVariables";
import CM from "../../../model/system/CM";
import ActualizeVariables from "../../../model/service/campaign/dto/ActualizeVariables";
import {toast} from "react-toastify";
import SynchronizeVariables from "../../../model/service/campaign/dto/SynchronizeVariables";
import UpdateVariableGroups from "../../../model/service/campaign/dto/UpdateVariableGroups";
import DataType from "../../../../lib/model/types/DataType";
import GF from "../../../../lib/utils/GF";
import ReadVariableGroups from "../../../model/service/campaign/dto/ReadVariableGroups";
import CampaignService from "../../../model/service/campaign/CampaignService";
import Resource from "../../../../lib/model/resource/Resource";
import ConfirmationDialog from "../../../../lib/components/dialogs/ConfirmationDialog";
import * as JSON from "postcss";
import window from "../../../../lib/components/window/Window";

class VariablesForm extends BaseComponent {

  constructor(props) {
    super(props);
    this.tabContainerRef = createRef();
    this.variableGroupButtonRefs = {};
    this.fileInProgress = 0;
    this.state = {
      variableGroupDefs: this.props.variableGroupDefs,
      variables: this.props.variables,
      pages: this.props.pages,
      createBlockingField: []
    };
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadVariables();
  }

  loadVariables() {
    let self = this;
    this.state.variableGroupDefs = {};
    this.state.variables = {};
    this.state.pages = [];

    this.doDataFetch(new ReadVariableGroups(this.props.campaignId), 'campaign', (response) => {
      if (response.success) {
        self.state.variableGroupDefs = response.data.variableGroupDefinitions;
        self.state.variables = response.data.variables;
        self.state.pages = response.data.pages;
        self.state.openSendingsInfo = this.private_filterCampaignIdFromOpenSendingsInfo(this.props.campaignId,
          response.data.openSendingsInfo);
        self.state.mailTemplates = response.data.mailTemplates;

        self.tabContainerRef.current.clearAll();
        let firstIndex = '';
        for (let index in self.state.variableGroupDefs) {
          let variableGroupDef = self.state.variableGroupDefs[index];
          let variableGroupButtonRef = createRef();
          let variableGroupValues = self.state.variables[self.props.variant][variableGroupDef.name];

          if (variableGroupValues !== undefined) {
            self.checkHasOpenSendings(variableGroupDef.name, self.state.openSendingsInfo);

            let id = self.tabContainerRef.current.addElement(
              <ButtonTabVariables ref={variableGroupButtonRef}>{variableGroupDef.description}</ButtonTabVariables>,
              <VariablesContent campaignId={this.props.campaignId} variableGroup={variableGroupDef}
                                onVariablesChange={(variableGroupDef, variableName, value) => self.onVariablesChange(
                                  variableGroupDef, variableName, value)}
                                variableValues={self.state.variables[self.props.variant][variableGroupDef.name]}
                                myVariablesForm={self}
              />);

            self.variableGroupButtonRefs[variableGroupDef.name] = variableGroupButtonRef;
            if (parseInt(index) === 0) {
              firstIndex = id;
            }
          }
        }
        self.tabContainerRef.current.setActiveElement(firstIndex);
      } else {
        toast.error('Variablen konnten nicht geladen werden!');
      }
    });
  }

  /**
   * Diese Funktion ermittelt anhand des Action-Jobs, ob es sich um die eigene Campaign handelt
   *
   * @param campaignId
   * @param openSendingsInfo
   * @returns {{data: *[]}}
   */
  private_filterCampaignIdFromOpenSendingsInfo(campaignId, openSendingsInfo) {
    let affectedSendings = [];
    for (let index in openSendingsInfo.data) {
      let openSendingInfoString = openSendingsInfo.data[index];
      let openSendingInfo = null;
      try {
        openSendingInfo = JSON.parse(openSendingInfoString);
        if (openSendingInfo && openSendingInfo.hasOwnProperty('data')) {
          openSendingInfo = openSendingInfo.data;
        } else {
          openSendingInfo = null;
        }
      } catch (e) {
      }
      if (openSendingInfo && openSendingInfo.hasOwnProperty('listName')) {
        let openSendingInfoParts = openSendingInfo.listName.split('_');
        if (openSendingInfoParts && openSendingInfoParts.length === 2 && campaignId ===
          parseInt(openSendingInfoParts[1])) {
          affectedSendings.push(openSendingInfoString);
        }
      }
    }
    return {data: affectedSendings};
  }

  checkHasOpenSendings(variableGroupName, openSendingsInfo) {
    const regToCheck = /(mass)|(temp)|(sms)|([0-9]+)/gmi;
    const result = [...variableGroupName.matchAll(regToCheck)].map(m => m[0]);

    let foundSending = false;

    if (result.length >= 3 && result[0].toLowerCase() === 'mass' && result[1].toLowerCase() === 'temp') {
      let templateName = '';

      if (result[2].toLowerCase() === 'sms') {
        if (result.length === 4) {
          templateName = 'SMS ' + result[3];
        } else {
          templateName = 'SMS';
        }
      } else {
        if (result.length === 3) {
          templateName = 'Template ' + result[2];
        } else {
          templateName = 'Template 1';
        }
      }
      for (let index in openSendingsInfo.data) {
        let openSendingInfo = openSendingsInfo.data[index];
        if (openSendingInfo) {
          let openSendingInfoObj = JSON.parse(openSendingInfo);
          if (openSendingInfoObj.data.template === templateName) {
            foundSending = true;
            break;
          }
        }
      }
    }
    this.state.createBlockingField[variableGroupName] = foundSending;
  }

  getBlockingField(index) {
    return this.state.createBlockingField[index];
  }

  setBlockingField(index, blocking) {
    this.state.createBlockingField[index] = blocking;
  }

  onVariablesChange(variableGroupDef, variableName, value) {
    let fieldValue;
    if (value.hasOwnProperty('currentTarget')) {
      fieldValue = value.currentTarget.value;
    } else {
      fieldValue = value;
    }
    let variableGroup = this.state.variables[this.props.variant][variableGroupDef.name];

    if (variableGroup[variableName].value !== fieldValue) {
      this.variableGroupButtonRefs[variableGroupDef.name].current.setIsChanged(true);
    }
    variableGroup[variableName].value = fieldValue;
    this.state.variables[this.props.variant][variableGroupDef.name] = variableGroup;
  }

  onOverwriteButtonClick(e) {
    let doOverwriteVars = (e) => {
      CM.get().doJsonAjax(CM.get().getServiceUrl('campaign'), new ActualizeVariables(this.props.campaignId),
        (response) => {
          if (response.success) {
            this.clearCache(this.getStorageId());
            this.loadVariables();
            CM.get().closeMainDialog(e);
            toast.success('Variablen wurden erfolgreich überschrieben.');
          } else {
            if (response.message != null) {
              toast.error(response.message);
            } else {
              toast.error('Variablen konnten nicht überschrieben werden!');
            }
          }
        });
    }

    let overrideVariables = <ConfirmationDialog
      title={'Variablen überschreiben'}
      onCancelClick={e => CM.get().closeMainDialog(e)}
      onConfirmClick={doOverwriteVars}>
      Möchten Sie die Variablen überschreiben?
    </ConfirmationDialog>

    CM.get().setMainDialog(overrideVariables);
  }

  onVariablesButtonGroupClick(e, buttonId) {
    switch (buttonId) {
      case VariablesButtonGroup.REFRESH:
        this.loadVariables();
        break;
      case VariablesButtonGroup.OVERWRITE:

        this.onOverwriteButtonClick(e);
        break;
      case VariablesButtonGroup.SYNC:
        CM.get().doJsonAjax(CM.get().getServiceUrl('campaign'),
          new SynchronizeVariables(this.props.campaignId, this.props.variant), (response) => {
            if (response.success) {
              this.loadVariables();
              toast.success('Variablen wurden erfolgreich synchronisiert.');
            } else {
              toast.error('Variablen konnten nicht synchronisiert werden!');
            }
          });
        break;
      case VariablesButtonGroup.CANCEL:
        this.loadVariables();
        break;
      case VariablesButtonGroup.SHOW:
        window.open(this.props.campaignHref, '_blank');
        break;
      case VariablesButtonGroup.SAVE:
        this.doSaveVariables();
        break;
    }
  }

  doSaveVariables() {
    this.prepareFileUpload(this.state.variables, () => {
      let dtoUpdateVariableGroups = new UpdateVariableGroups(this.props.campaignId,
        this.prepareVariablesForServer(this.state.variables), [this.props.variant]);

      CM.get().doJsonAjax(CM.get().getServiceUrl('campaign'), dtoUpdateVariableGroups, (response) => {
        if (response.success) {
          for (let index in this.variableGroupButtonRefs) {
            let variableGroupButtonRef = this.variableGroupButtonRefs[index];
            if (variableGroupButtonRef.current !== null) {
              variableGroupButtonRef.current.setIsChanged(false);
            }
          }
          toast.success('Variablen wurden erfolgreich gespeichert.');
        } else {
          toast.error('Variablen konnten nicht gespeichert werden!');
        }
      });
    });
  }

  prepareFileUpload(variables, doSaveCallback) {
    let collectedFiles = [];
    this.iterateObjectTree(variables, (index, variant) => {
      return this.iterateObjectTree(variant, (index, variableGroup) => {
        return this.iterateObjectTree(variableGroup, (index, variableValue) => {
          if (variableValue !== undefined && variableValue !== null && Object.keys(variableValue).length > 0) {
            switch (variableValue.variableDef.type.type) {
              case DataType.DATA_EXT:
                if (typeof variableValue.value === 'object') {
                  collectedFiles.push(variableValue.value);
                }
                break;
              default:
                break;
            }
          }
          return variableValue;
        });
      });
    });
    if (collectedFiles.length > 0) {
      let dtoProperties = CampaignService.createCampaignRedirectProperty(this.props.campaignId);
      let resource = new Resource(dtoProperties);

      resource.doManageResources(collectedFiles, () => {
        doSaveCallback();
      })
    } else {
      doSaveCallback();
    }
  }

  prepareVariablesForServer(variables, doSaveCallback) {
    return this.iterateObjectTree(variables, (index, variant) => {
      return this.iterateObjectTree(variant, (index, variableGroup) => {
        return this.iterateObjectTree(variableGroup, (index, variableValue) => {
          let variableNew = null;
          if (variableValue !== undefined && variableValue !== null && Object.keys(variableValue).length > 0) {
            switch (variableValue.variableDef.type.type) {
              case DataType.STRING:
                if (variableValue.variableDef.type.isPassword && variableValue.value === GF.PASSWORD_PLACEHOLDER) {
                  // nicht übernehmen
                } else {
                  variableNew = variableValue.value;
                }
                break;
              case DataType.BOOLEAN:
                variableNew = variableValue.value === "1" || variableValue.value === "true" || variableValue.value ===
                  "ja" || variableValue.value === "JA" || variableValue.value === 1 || variableValue.value === true;
                break;
              case DataType.DATA_EXT:
                if (typeof variableValue.value === 'object') {
                  variableNew = variableValue.value.getResourceIdAndName();
                  variableValue.value = variableNew;
                } else {
                  variableNew = variableValue.value;
                }
                break;
              default:
                variableNew = variableValue.value;
                break;
            }
          }
          return variableNew;
        });
      });
    });
  }

  iterateObjectTree(objectData, callBack) {
    let objectNew = {};
    for (let index in objectData) {
      let value = objectData[index];
      let result = callBack(index, value);
      if (result !== null) {
        objectNew[index] = result;
      }
    }
    return objectNew;
  }

  render() {
    let hideOverwriteButton = this.props.variant !== 'std';
    return <Window className='h-full overflow-hidden pl-2 pb-[80px]' title='Variablen'>
      <VerticalLayout className='h-full'>
        <VariablesButtonGroup
          hideOverwriteButton={hideOverwriteButton}
          onClick={(e, data) => this.onVariablesButtonGroupClick(e, data)}/>
        <TabContainerVerticalVariables className='py-2 h-full ' ref={this.tabContainerRef} tabBar={
          <TabBarVertical widthFit className='min-w-[50px] gap-1 pr-[4px]'/>} tabContent={
          <TabContent className='overflow-y-scroll pl-3 pr-2 pb-[8px]'/>}/>
      </VerticalLayout>
    </Window>;
  }
}

VariablesForm.propTypes = {
  variant: PropType.string,
  variableGroupDefs: PropType.array,
  campaignId: PropType.number,
  campaignHref: PropType.string,
  variables: PropType.object,
  pages: PropType.array,
}

export default VariablesForm;
